export default __webpack_public_path__ + "static/media/or_5.b1b2092c.mp3";